/**
 * Dashboard Page
 * Uses design system DashboardLayout and DashboardHome components
 */
import { DashboardLayout } from '../../components/dashboard/DashboardLayout';
import { DashboardHome } from '../../components/dashboard/DashboardHome';

const DashboardPage = () => {
  return (
    <DashboardLayout currentPage="dashboard">
      <DashboardHome />
    </DashboardLayout>
  );
};

export default DashboardPage;

